/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferBlock} from "./offerBlock.zod";

export const offerChapterApplyCommissionDefault = true;
export const offerChapterOptionalDefault = false;

export const OfferChapter = zod
  .object({
    chapterId: zod.uuid(),
    title: zod.string(),
    applyCommission: zod
      .boolean()
      .default(offerChapterApplyCommissionDefault)
      .describe(
        "Authored commission applicability. New chapter authoring initializes true; full replacement carries the explicit value so false is not lost. False uses effective commission zero without changing or repairing the captured agreement. Independent of remembering.",
      ),
    blocks: zod.array(OfferBlock),
    optional: zod
      .boolean()
      .default(offerChapterOptionalDefault)
      .describe(
        "Structural quoted add-on, not selection state. Excluded from ordinary Offer financials, but fully evaluated and validated for progression. Missing means ordinary in legacy inputs and documents; explicit null is invalid.",
      ),
  })
  .describe(
    "List order owns position; block IDs are unique per Chapter. Coefficients are forbidden in authored Customer\/Template content and exist only as protected Customer pricing decisions. Optionality and explicit commission applicability survive replacement, reorder, Template opening and complete Customer succession independently of remembering. Omitted optionality retains its ordinary false convention.",
  );

export type OfferChapter = zod.input<typeof OfferChapter>;
export type OfferChapterOutput = zod.output<typeof OfferChapter>;
